import React from 'react';
import { InputNumber } from 'primereact/inputnumber';

/**
 * Denetim formu kriter tablosu. 1. ekran görselindeki düzeni taklit eder:
 * Kriter | Sıralama | Alt Kriter | Değerlendirme Kriter | Değerlendirme | Puan | Denetim
 * "Denetim" sütunu, her alt kriter için tek puan girişidir (değerlendirme satırları boyunca birleşir).
 */
const cellStyle = { border: '1px solid var(--surface-border)', padding: '6px 8px', verticalAlign: 'middle' };
const headerStyle = {
    ...cellStyle,
    backgroundColor: 'var(--surface-100)',
    fontWeight: 600,
    textAlign: 'center'
};

const AuditCriteriaTable = ({ template, scores, setScore, readOnly, th }) => {
    return (
        <div style={{ overflowX: 'auto' }}>
            <table style={{ borderCollapse: 'collapse', width: '100%', minWidth: '900px' }}>
                <thead>
                    <tr>
                        <th style={headerStyle}>{th('warrantyAudit.fields.criterion') || 'Kriter'}</th>
                        <th style={{ ...headerStyle, width: '80px' }}>{th('warrantyAudit.fields.sort') || 'Sıralama'}</th>
                        <th style={headerStyle}>{th('warrantyAudit.fields.subCriterion') || 'Alt Kriter'}</th>
                        <th style={headerStyle}>{th('warrantyAudit.evaluation.criterionText') || 'Değerlendirme Kriter'}</th>
                        <th style={headerStyle}>{th('warrantyAudit.evaluation.evaluationText') || 'Değerlendirme'}</th>
                        <th style={{ ...headerStyle, width: '70px' }}>{th('warrantyAudit.fields.point') || 'Puan'}</th>
                        <th style={{ ...headerStyle, width: '120px' }}>{th('warrantyAudit.fields.auditScore') || 'Denetim'}</th>
                    </tr>
                </thead>
                <tbody>
                    {(template || []).map((criterion) => {
                        const subList = criterion.subCriteria || [];
                        const criterionRowSpan = subList.reduce(
                            (acc, s) => acc + Math.max(1, (s.evaluations || []).length),
                            0
                        );
                        let criterionCellRendered = false;

                        return subList.map((sub) => {
                            const evals = sub.evaluations || [];
                            const subRowSpan = Math.max(1, evals.length);
                            const rows = evals.length > 0 ? evals : [null];

                            return rows.map((evaluation, evalIdx) => {
                                const isFirstSubRow = evalIdx === 0;
                                const cells = [];

                                if (!criterionCellRendered) {
                                    criterionCellRendered = true;
                                    cells.push(
                                        <td key="criterion" style={{ ...cellStyle, fontWeight: 600 }} rowSpan={criterionRowSpan}>
                                            {criterion.name}
                                        </td>
                                    );
                                }

                                if (isFirstSubRow) {
                                    cells.push(
                                        <td key="sort" style={{ ...cellStyle, textAlign: 'center' }} rowSpan={subRowSpan}>
                                            {sub.displayCode || sub.sort}
                                        </td>
                                    );
                                    cells.push(
                                        <td key="sub" style={cellStyle} rowSpan={subRowSpan}>
                                            {sub.name}
                                        </td>
                                    );
                                }

                                cells.push(
                                    <td key="critText" style={cellStyle}>
                                        {evaluation?.criterionText || ''}
                                    </td>
                                );
                                cells.push(
                                    <td key="evalText" style={cellStyle}>
                                        {evaluation?.evaluationText || ''}
                                    </td>
                                );
                                cells.push(
                                    <td key="point" style={{ ...cellStyle, textAlign: 'center' }}>
                                        {evaluation?.point != null ? evaluation.point : ''}
                                    </td>
                                );

                                if (isFirstSubRow) {
                                    cells.push(
                                        <td key="score" style={{ ...cellStyle, textAlign: 'center' }} rowSpan={subRowSpan}>
                                            <InputNumber
                                                value={scores[sub.id] ?? null}
                                                onValueChange={(e) => setScore(sub.id, e.value)}
                                                min={0}
                                                max={sub.maxScore ?? undefined}
                                                disabled={readOnly}
                                                inputStyle={{ width: '70px', textAlign: 'center' }}
                                                placeholder={`0-${sub.maxScore ?? ''}`}
                                            />
                                        </td>
                                    );
                                }

                                return <tr key={`${sub.id}-${evalIdx}`}>{cells}</tr>;
                            });
                        });
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default AuditCriteriaTable;
